import { render } from "./PresentationSlideOne.vue?vue&type=template&id=e70f6d06&scoped=true"
const script = {}

import "./PresentationSlideOne.vue?vue&type=style&index=0&id=e70f6d06&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e70f6d06"]])

export default __exports__